import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { type PaymentMethodTranslations } from './types';

interface DeleteConfirmDialogProps {
  open: boolean;
  t: PaymentMethodTranslations;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmDialog({ open, t, onCancel, onConfirm }: DeleteConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent className="bg-background border-border max-w-[90vw] sm:max-w-md rounded-[10px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground text-lg">
            {t.deleteCard}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground text-sm">
            {t.confirmDelete}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-row gap-3 sm:gap-3">
          <AlertDialogCancel
            onClick={onCancel}
            className="flex-1 bg-muted text-foreground font-bold border-0 hover:bg-muted/80 h-[50px] rounded-[5px] m-0 transition-all"
          >
            {t.cancel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="flex-1 bg-warning text-white font-bold hover:bg-warning/90 h-[50px] rounded-[5px] m-0 transition-all"
          >
            {t.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
